import { BaseApiService } from "@mirage/services/BaseApiService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { IPWeeklyList } from "@shared/publicportal/entities/IPWeeklyList";
import { IWeeklyListsService } from "@shared/publicportal/services/IWeeklyListsService";

export default class WeeklyListsService extends BaseApiService implements IWeeklyListsService {
    constructor() {
        super("publicportal/weeklyLists");
    }

    async pageRequest(pageRequest: IEntityPageRequest): Promise<IEntityPageResult<IPWeeklyList>> {
        const response = await this.httpInstance().post("/pageRequest", pageRequest);
        return response.data;
    }
}
